var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { action, observable, runInAction, set, configure } from "mobx";
import { isNotBlankArray } from "../../../utils/array";
configure({ isolateGlobalState: true, enforceActions: "observed" });
export default class ProductStore {
    constructor(modules) {
        this.productsListMap = {};
        this.isLoadingProducts = {};
        this.isLoadEnd = { "5ea502e8ff03863be63f6e73": true };
        this.loadProductsList = (poolIds = [], onLoadPool, index) => __awaiter(this, void 0, void 0, function* () {
            const poolId = poolIds === null || poolIds === void 0 ? void 0 : poolIds[0];
            if (this.isLoadingProducts[poolId] || this.isLoadEnd[poolId]) {
                return;
            }
            set(this.isLoadingProducts, { [poolId]: true });
            try {
                const res = yield onLoadPool({
                    poolIds,
                    tagIndex: index
                });
                if (isNotBlankArray(res === null || res === void 0 ? void 0 : res.products)) {
                    runInAction("update product list", () => {
                        if (!this.productsListMap[poolId]) {
                            set(this.productsListMap, { [poolId]: res.products });
                        }
                        else {
                            set(this.productsListMap, {
                                [poolId]: this.productsListMap[poolId].concat(res.products),
                            });
                        }
                        if (!res.hasNext) {
                            set(this.isLoadEnd, { [poolId]: true });
                        }
                    });
                }
            }
            catch (e) {
                console.error("GetProducts Got error", e);
            }
            finally {
                runInAction(() => {
                    set(this.isLoadingProducts, { [poolId]: false });
                });
            }
        });
        modules.forEach(item => {
            const mapKey = !!item.poolId ? item.poolId : item.activeId;
            set(this.productsListMap, {
                [mapKey]: item.productElements || [],
            });
            set(this.isLoadEnd, {
                [mapKey]: item.hasNext || isNotBlankArray(item.productElements)
            });
        });
    }
}
__decorate([
    observable
], ProductStore.prototype, "productsListMap", void 0);
__decorate([
    observable
], ProductStore.prototype, "isLoadingProducts", void 0);
__decorate([
    observable
], ProductStore.prototype, "isLoadEnd", void 0);
__decorate([
    action
], ProductStore.prototype, "loadProductsList", void 0);
export const transformPoolIds = (productModules = []) => {
    return productModules.reduce((r, p) => {
        const poolId = p.activeId || p.poolId || "";
        return [...r, poolId];
    }, []);
};
